export const isMasterVariation = (item) => item.selections?.variationType === "master"